module.exports = __webpack_public_path__ + "static/assets/9ab81e72a33cbb1fc653d7c57b77b9c7.png";